import { DwModalService } from '@devwareapps/devware-cap';
import { EMPTY, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ProfileFriendsService } from './profile-friends.service';

export function confirmFriendRemoval(dialogs: DwModalService, friends: ProfileFriendsService,
    id: number, name: string, isCurrent: () => boolean): Observable<void> {
    return dialogs.showConfirmDialog({ title: 'Remove friend?', message: 'Remove ' + name + ' from your friends?',
        useConfirmDefaults: true, showConfirmDialog: true }).pipe(take(1),
        switchMap(confirmed => confirmed && isCurrent() ? friends.remove(id) : EMPTY));
}
